import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { usePostHog } from './PostHogProvider';
import ChatInput from './ChatInput';
import backgroundImage from '../assets/ChatWDL_bg.jpg';
import './Home.css';

export const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const { posthog, isInitialized } = usePostHog();
  const [inputMessage, setInputMessage] = React.useState('');

  // Debug logging
  React.useEffect(() => {
    console.log('Home component - PostHog status:', {
      isInitialized,
      hasPostHog: !!posthog,
      isAuthenticated
    });
  }, [isInitialized, posthog, isAuthenticated]);

  // Track page view when Home component mounts
  React.useEffect(() => {
    if (posthog && isInitialized) {
      console.log('Capturing home_page_viewed event');
      // posthog.capture('home_page_viewed', {
      //   distinct_id: user?.sub,
      //   email: user?.email,
      //   name: user?.name,
      //   timestamp: new Date().toISOString()
      // });
    } else {
      console.log('PostHog not ready for home_page_viewed event:', {
        hasPostHog: !!posthog,
        isInitialized
      });
    }
  }, [posthog, isInitialized, isAuthenticated]);

  // Clear any pending question when Home component mounts
  React.useEffect(() => {
    localStorage.removeItem('chat_wdl_pending_question');
  }, []);

  const handleSubmit = (message) => {
    if (message.trim()) {
      // Track question submission attempt
      if (posthog && isInitialized) {
        console.log('Capturing home_question_submitted event');
        // posthog.capture('home_question_submitted', {
        //   distinct_id: user?.sub,
        //   email: user?.email,
        //   name: user?.name,
        //   question: message,
        //   timestamp: new Date().toISOString()
        // });
      } else {
        console.log('PostHog not ready for home_question_submitted event');
      }

      if (!isAuthenticated) {
        console.log('Saving pending question to localStorage:', message);
        localStorage.setItem('chat_wdl_pending_question', message);
        
        // Track authentication redirect
        if (posthog && isInitialized) {
          console.log('Capturing auth_redirect_triggered event');
          // posthog.capture('auth_redirect_triggered', {
          //   distinct_id: user?.sub,
          //   email: user?.email,
          //   name: user?.name,
          //   timestamp: new Date().toISOString()
          // });
        }

        loginWithRedirect({
          appState: { returnTo: '/chat' }
        });
      } else {
        // Track navigation to chat with initial message
        if (posthog && isInitialized) {
          console.log('Capturing navigate_to_chat_with_message event');
          // posthog.capture('navigate_to_chat_with_message', {
          //   distinct_id: user?.sub,
          //   email: user?.email,
          //   name: user?.name,
          //   question: message,
          //   timestamp: new Date().toISOString()
          // });
        }

        navigate('/chat', { state: { initialMessage: message } });
      }
    }
  };

  const handleInputChange = (value) => {
    setInputMessage(value);
    
    // Track input activity (throttled to avoid spam)
    if (posthog && isInitialized && value.length > 0) {
      console.log('Capturing home_input_typing event');
      // posthog.capture('home_input_typing', {
      //   distinct_id: user?.sub,
      //   email: user?.email,
      //   name: user?.name,
      //   timestamp: new Date().toISOString()
      // });
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setInputMessage(suggestion);
    
    // Track suggestion click on home page
    if (posthog && isInitialized) {
      console.log('Capturing home_suggestion_clicked event');
      // posthog.capture('home_suggestion_clicked', {
      //   distinct_id: user?.sub,
      //   email: user?.email,
      //   name: user?.name,
      //   suggestion: suggestion,
      //   timestamp: new Date().toISOString()
      // });
    } else {
      console.log('PostHog not ready for home_suggestion_clicked event');
    }
  };

  if (isAuthenticated) {
    // Track automatic redirect for authenticated users
    if (posthog && isInitialized) {
      console.log('Capturing home_authenticated_redirect event');
      // posthog.capture('home_authenticated_redirect', {
      //   distinct_id: user?.sub,
      //   email: user?.email,
      //   name: user?.name,
      //   timestamp: new Date().toISOString()
      // });
    }
    
    navigate('/chat');
    return null;
  }

  return (
    <div className="home-main home-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="welcome-container">
        <h1 className="welcome-title">The Ultimate Petro Nerd</h1>
        <p className="welcome-subtitle">AI reasoning models trained for the oilfield</p>
      </div>
      <ChatInput 
        mode="home"
        onSubmit={handleSubmit} 
        value={inputMessage} 
        onChange={handleInputChange}
        onSuggestionClick={handleSuggestionClick}
      />
    </div>
  );
};

export default Home; 